import React from 'react';
import styled from 'styled-components';
import { Container, Row as UnstyledRow } from 'styled-bootstrap-grid';
import useTranslation from 'next-translate/useTranslation';
import { useBlockUnblockUser, useUser } from '../../api';

import Modal from '../common/Modal';

import { CenteredLoader } from '../common/Loader';
import CentralizeButton from '../../VuexyDesign/atoms/CentralizeButton';

interface Props {
  toggle: (open: boolean) => void;
  open: boolean;
  userId: number;
}

const BlockUserModal = ({ open, toggle, userId }: Props) => {
  const { data: user, isFetching } = useUser(userId);
  const {
    block: { mutateAsync: block },
    unblock: { mutateAsync: unblock },
  } = useBlockUnblockUser(userId);

  const { t } = useTranslation('modals');

  const title =
    isFetching && !user
      ? `${t('modals:loading')}`
      : `${user?.blocked ? t('modals:unblock') : t('modals:block')} ${t(
          'modals:user',
        )}`;

  return (
    <Modal isOpened={open} toggle={toggle} title={title}>
      {!!(isFetching && !user) && <CenteredLoader />}
      {user && (
        <Container>
          <Row>
            {t('modals:sureCheck')}{' '}
            {user.blocked ? t('modals:unblock') : t('modals:block')}{' '}
            {user.display_name}?
          </Row>
          <Row>
            <CentralizeButton
              onClick={() => (user.blocked ? unblock() : block())}
              text={`${
                user.blocked ? t('modals:unblock') : t('modals:block')
              } ${t('modals:user')}`}
              size="sm"
            />
          </Row>
        </Container>
      )}
    </Modal>
  );
};

const Row = styled(UnstyledRow)`
  justify-content: center;
  margin-bottom: 15px;
`;

export default BlockUserModal;
